import { Component } from '@angular/core';
import { TitleCardModel } from '../../../../models/title-card.model';

@Component({
  selector: 'app-participants',
  templateUrl: './participants.component.html',
  styleUrl: './participants.component.scss',
  standalone: false,
})
export class ParticipantsComponent {
  public titleCard: TitleCardModel = {
    image: '../../../assets/images/placeholder.svg',
  };
}
